import React, { Component } from "react";
import { StyleSheet, View } from "react-native";
import SText from "styled42/components/SText";
import {
  removeDataFromAsyncStorage,
  retrieveDataFromAsyncStorage,
  storeDataToAsyncStorage
} from "screens/common/utils";
import { delValue, setValue } from "utils/LocalKeyValueStorage";
import SClickableArea from "styled42/components/SClickableArea";
import S3Image from "screens/common/S3Image";
import SButton from "styled42/components/SButton";
import VernacManager from "utils/vernacular";
import { pushClevertapEvent } from "utils/clevertapEvents";
import { updateAppLanguage } from "./utils";

const languageOptions = [
  {
    label: "English",
    value: "English",
    name: "English",
    unselectedImage: "lang_english_unselect",
    selectedImage: "lang_english_select"
  },
  {
    label: "Hindi",
    value: "Hindi",
    name: "हिंदी",
    unselectedImage: "lang_hindi_unselect",
    selectedImage: "lang_hindi_select"
  },
  {
    label: "Hinglish",
    value: "Hinglish",
    name: "Thoda English",
    unselectedImage: "lang_hinglish_unselect",
    selectedImage: "lang_hinglish_select"
  }
];

const langShortHand = {
  English: "ENG",
  Hindi: "HIN",
  Hinglish: "HNS"
};

class LanguageSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      languageSelected: null,
      prevLanguageSelected: null
    };
  }

  async componentDidMount() {
    const { profilePage } = this.props;
    const languageChanged = await retrieveDataFromAsyncStorage(
      "LanguageChanged"
    );

    if (languageChanged) {
      const languageSelected = languageOptions.filter(
        (item) => item.value === languageChanged
      );

      if (languageSelected.length) {
        this.setState({
          languageSelected: languageSelected[0],
          prevLanguageSelected: languageSelected[0].value
        });
      }
    }

    pushClevertapEvent("Page Load", {
      Current_Page: profilePage ? "editProfile" : "New loginRegistration",
      Page_Modal: "Edit App language"
    });
  }

  handleClose = () => {
    const { prevLanguageSelected } = this.state;
    const { onClose, profilePage } = this.props;

    pushClevertapEvent("General Clicks", {
      Current_Page: profilePage ? "editProfile" : "New loginRegistration",
      Page_Modal: "Edit App language",
      Type: "close"
    });

    //  reset the value to previous selected language
    if (prevLanguageSelected) {
      storeDataToAsyncStorage("LanguageChanged", prevLanguageSelected);
      setValue("LanguageChanged", prevLanguageSelected);
    } else {
      removeDataFromAsyncStorage("LanguageChanged");
      delValue("LanguageChanged");
    }

    storeDataToAsyncStorage("ShowLanguagePage", true);
    this.setState({
      languageSelected: null
    });

    onClose();
  };

  handleChange = (itemValue) => {
    const { profilePage } = this.props;
    const { value } = itemValue;

    pushClevertapEvent("General Clicks", {
      Current_Page: profilePage ? "editProfile" : "New loginRegistration",
      Page_Modal: "Edit App language",
      Type: value
    });

    this.setState({
      languageSelected: itemValue
    });

    storeDataToAsyncStorage("LanguageChanged", value);
    setValue("LanguageChanged", value);
  };

  handleSubmit = async () => {
    const { onClose, client, candId, profilePage } = this.props;
    const { languageSelected } = this.state;

    pushClevertapEvent("General Clicks", {
      Current_Page: profilePage ? "editProfile" : "New loginRegistration",
      Page_Modal: "Edit App language",
      Type: "Save"
    });

    if (languageSelected?.value && profilePage) {
      const payload = {
        app_language: langShortHand[languageSelected.value]
      };
      const { data, error } = await updateAppLanguage(candId, payload, client);
    }

    storeDataToAsyncStorage("ShowLanguagePage", true);
    await VernacManager.initialize();
    onClose();
  };

  render() {
    const { languageSelected } = this.state;
    const { language, profilePage } = this.props;

    return (
      <View
        style={{
          height: "100%"
        }}
      >
        <SClickableArea
          containerStyle={{
            marginLeft: "auto",
            paddingTop: 10,
            paddingRight: 10
          }}
          onClick={this.handleClose}
        >
          <S3Image
            path="Close/Line/24px"
            name="Primary 1000"
            islazyLoadRequired={false}
            style={styles.crossImage}
          />
        </SClickableArea>

        <View style={{ paddingTop: "20%", paddingHorizontal: 16 }}>
          {!profilePage && (
            <SText color="#696F7C" size={20}>
              {VernacManager.translateString("vernacular_welcome")}
            </SText>
          )}
          <View style={{ flexDirection: "row", marginBottom: 32 }}>
            {profilePage ? (
              <SText color="#050F24" size={20}>
                {VernacManager.translateString(
                  "vernacular_change_app_language"
                )}
              </SText>
            ) : (
              <>
                <SText color="#050F24" size={20}>
                  {VernacManager.translateString(
                    "vernacular_please_select_app"
                  )}
                </SText>
                <SText
                  color="#050F24"
                  size={20}
                  weight="600"
                  containerStyle={{ marginLeft: 4 }}
                >
                  {VernacManager.translateString("jd_language")}
                </SText>
              </>
            )}
          </View>
          {languageOptions.map((lang) => {
            const languageCheck =
              languageSelected && languageSelected.value === lang.value;

            return (
              <SClickableArea
                onClick={() => {
                  this.handleChange(lang);
                }}
              >
                <View
                  style={[
                    styles.languageCard,
                    languageCheck ? styles.selectedLanguageCard : ""
                  ]}
                >
                  <View style={{ paddingBottom: 20 }}>
                    <SText
                      size={16}
                      color={languageCheck ? "#FF8718" : "#050F24"}
                    >
                      {lang.name}
                    </SText>
                    <SText
                      size={12}
                      color="#696F7C"
                      containerStyle={{ marginTop: 4 }}
                    >
                      {lang.label}
                    </SText>
                  </View>
                  <S3Image
                    path="OlxIntegration"
                    name={
                      languageCheck ? lang.selectedImage : lang.unselectedImage
                    }
                    style={{
                      height: 46,
                      width: 41,
                      marginLeft: "auto",
                      marginRight: 5,
                      marginTop: "auto"
                    }}
                  />
                </View>
              </SClickableArea>
            );
          })}
        </View>

        <SButton
          onClick={this.handleSubmit}
          text={VernacManager.translateString("generic_save")}
          containerStyle={{
            marginHorizontal: 16,
            borderRadius: 8,
            marginTop: 100,
            marginBottom: 24
          }}
        />
      </View>
    );
  }
}

export default LanguageSetting;

const styles = StyleSheet.create({
  languageCard: {
    paddingTop: 16,
    paddingLeft: 16,
    borderWidth: 1,
    borderColor: "#D6D6DA",
    marginBottom: 16,
    borderRadius: 8,
    flexDirection: "row"
  },
  selectedLanguageCard: {
    borderColor: "#FF8718",
    backgroundColor: "#FFF3E8"
  },
  crossImage: {
    width: 20,
    height: 20
  }
});
